import React, { useState, useEffect, useRef } from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, LinkWithArrow, Link } from 'newComponents'
import quoteMarks from '../../images/blog/quote-marks.png'
import openQuotes from '../../images/about-us/Quotes_v2_Blue.svg'
import './styles.scss'

const BreakoutQuote = (props) => {
  const { data, location, isEbook } = props
  const { primary, items } = data
  const {
    quote,
    role,
    avatar,
    author,
    logo,
    case_study_link: caseLink,
    case_study_link_text: caseLinkText,
    case_study_logo: caseLogo,
    case_study_text: caseText
  } = primary

  const [activeQuote, setActiveQuote] = useState(0)
  const timeoutRef = useRef()

  useEffect(() => {
    if (items) {
      timeoutRef.current = setTimeout(() => {
        const nextIndex = activeQuote === items.length - 1 ? 0 : activeQuote + 1
        setActiveQuote(nextIndex)
      }, 6000)
    }
  }, [activeQuote])

  const handleClick = (event, index) => {
    if (items) {
      event.preventDefault()
      clearTimeout(timeoutRef.current)
      setActiveQuote(index)
    }
  }

  const altRender = !location.pathname.includes('blog') ? 'page-variant' : ''
  // content checks
  const quoteHtml = quote?.html
  const roleHtml = role?.html
  const authorHtml = author?.html
  const hasAvatar = avatar?.url
  const caseTextHtml = caseText?.html
  const hasLogo = logo?.url

  const hasCaseCta = caseLink?.url && caseLinkText?.text

  const hasCaseStudy = caseText?.text
  const caseVariant = hasCaseStudy ? 'case-variant' : ''

  const isCarousel = items?.length > 1

  const showIconAtTop = caseLogo && caseLogo.url && caseLogo.url.length > 0 && !hasCaseStudy

  return (
    <OnVisible className={`breakout-quote ${altRender} ${caseVariant} ${isEbook ? 'ebook-variant' : ''}`}>
      <Section>
        {showIconAtTop && <Image className="breakout-quote-case-study-logo" image={caseLogo} />}
        <div className="breakout-quote-container">
          {quote.text && (
            <>
              {!isEbook && <Image className="breakout-quote-marks" image={quoteMarks} />}
              {hasLogo && <Image className="breakout-quote-logo" image={logo} />}
              {/* QUOTE TEXT */}
              <div>
                <div className="breakout-quote-content" dangerouslySetInnerHTML={{ __html: quoteHtml }} />
                <div className="breakout-quote-author-container">
                  {hasAvatar && <Image className="breakout-quote-author-image" image={avatar} />}
                  <div className="breakout-quote-author-text">
                    {authorHtml && (
                      <div className="breakout-quote-author-name" dangerouslySetInnerHTML={{ __html: authorHtml }} />
                    )}
                    {roleHtml && (
                      <div className="breakout-quote-author-role" dangerouslySetInnerHTML={{ __html: roleHtml }} />
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {isCarousel &&
            items.map((item, index) => {
              const { author: repeaterAuthor, avatar: repeaterAvatar, quote: repeaterQuote, role: repeaterRole } = item
              return (
                <div key={repeaterQuote.text} className={`breakout-quote-wrapper ${index === activeQuote ? 'breakout-quote-wrapper-active' : ''}`}>
                  <div className="breakout-quote-wrapper-inner">
                    {!isEbook && <Image className="breakout-quote-marks" image={openQuotes} />}
                    {hasLogo && <Image className="breakout-quote-logo" image={logo} />}
                    {/* QUOTE TEXT */}
                    <div>
                      {repeaterQuote && (
                        <div
                          className="breakout-quote-content"
                          dangerouslySetInnerHTML={{ __html: repeaterQuote.html }}
                        />
                      )}
                      <div className="breakout-quote-author-container">
                        {repeaterAvatar && <Image className="breakout-quote-author-image" image={repeaterAvatar} />}
                        <div className="breakout-quote-author-text">
                          {repeaterAuthor && (
                            <div
                              className="breakout-quote-author-name"
                              dangerouslySetInnerHTML={{ __html: repeaterAuthor.html }}
                            />
                          )}
                          {repeaterRole && (
                            <div
                              className="breakout-quote-author-role"
                              dangerouslySetInnerHTML={{ __html: repeaterRole.html }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="carousel-dots">
                    {items.map((q, index) => (
                      <Link key={index} to="#" onClick={(event) => handleClick(event, index)}>
                        <div className={`carousel-dot ${index === activeQuote ? 'carousel-active-dot' : ''}`}>
                          <span className="carousel-dot-inner" />
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )
            })}
        </div>
        {/* IF HAS CASE STUDY */}
        {hasCaseStudy && (
          <div className="breakout-quote-case-study">
            <div>
              {caseLogo && <Image className="breakout-quote-case-study-logo" image={caseLogo} />}
              {caseTextHtml && (
                <div className="breakout-quote-case-text" dangerouslySetInnerHTML={{ __html: caseTextHtml }} />
              )}
            </div>
            {hasCaseCta && (
              <LinkWithArrow to={caseLink.url} className="breakout-quote-case-cta" left>
                {caseLinkText.text}
              </LinkWithArrow>
            )}
          </div>
        )}
      </Section>
    </OnVisible>
  )
}

export default BreakoutQuote
